import { getDateFromDatetime } from "~/utils/date.js";
export class QueryBuilder {
    constructor(query = {}) {
        if (query.where) this.where = query.where; else this.where = {};
        if (query.order) this.order = query.order; else this.order = {};
    }
    getQuery() {
        let query = {};
        if (Object.keys(this.where).length > 0) {
            query.where = this.where;
        }
        if (Object.keys(this.order).length > 0) {
            query.order = this.order;
        }
        return query;
    }

    where(key, value) {
        this.where[key] = value;
        return this;
    }

    equals(key, value) {
        this.where[key] = {
            "equal": value
        };
        return this;
    }

    orderBy(key, value) {
        this.order[key] = value;
        return this;
    }


    toString() {
        return JSON.stringify(this.getQuery());
    }

    createdAtToDate() {
        let whereDate = this.where.created_at;
        if(whereDate.between && whereDate.between.length > 2){
            whereDate.between[0] = getDateFromDatetime(whereDate.between[0])
            whereDate.between[1] = getDateFromDatetime(whereDate.between[1])
        }
        this.where = {
            ...this.where,
            date: whereDate
        };
        delete this.where.created_at;
        this.order = {
            ...this.order,
            date: this.order.created_at
        }
        delete this.order.created_at
        
        return this;
    }

    createdAtToDatetime() {
        let whereDate = this.where.created_at;
        this.where = {
            ...this.where,
            datetime: whereDate
        };
        delete this.where.created_at;
        this.order = {
            ...this.order,
            datetime: this.order.created_at
        }
        delete this.order.created_at
        
        return this;
    }
}